/**
 * 404 page
 */
import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Container from './../components/core/Container';

const Home = ({error}) => {
  return (
    <Container>
    <Helmet>
      <title>News Not Found | BUIHA News</title>
      <meta name="description" content="The resource you are looking for could not be found." />
    </Helmet>
    <div className="text-center py-10">
      <h1 className="text-3xl font-semibold">Error 404! {error}</h1>
      <p className="pt-4 pb-2">Wrong changing room?</p>
      <Link to="/" className="mt-8 text-blue-500 hover:underline">Let's go back home</Link>
    </div>
  </Container>
  );
};

export default Home;